export default "__VITE_ASSET__oIQrGOP5__"